import {ObjectProperties} from './communicationProperties';
import {QueryableEnum, QueryableProperty} from '../queryableProperty';
import {SnippetType} from '../../../snippet/data/snippet';

export class SnippetProperties extends ObjectProperties {
  constructor() {
    super();
    this.properties = [
      // new QueryableProperty('wildcard', 'Wildcard', 'wildcard'),
      new QueryableProperty('name', 'Title', 'string', false),
      new QueryableProperty('description', 'Description', 'string', false),
      new QueryableProperty('html', 'Content', 'string', false),
      new QueryableProperty('link', 'External Link', 'string', false),
      new QueryableEnum('type', 'GODH.Application.Core.Entities.Snippet.SnippetType', 'Snippet Type', 'enum', false,
        {},
        [{name: 'Web', value: SnippetType.Web, icon: '', color: '#a0289a'},
          {name: 'Email', value: SnippetType.Email, icon: '', color: '#283ca0'},
          {name: 'Job', value: SnippetType.Job, icon: '', color: '#286ca0'}]),
      new QueryableProperty('createdBy', 'Creator', 'worker'),
      new QueryableProperty('creationDate', 'Creation Date', 'date'),
    ];
    this.sortingPropertyName = 'creationDate';
    this.sortingDescending = true;
  }
}

export class UserProperties extends ObjectProperties {
  constructor() {
    super();
    this.properties = [
      // new QueryableProperty('wildcard', 'Wildcard', 'wildcard'),
      new QueryableProperty('username', 'Username', 'string', false),
      new QueryableProperty('email', 'Email', 'string', false)
    ];
    this.sortingPropertyName = 'username';
    this.sortingDescending = false;
  }
}

